import { render, staticRenderFns } from "./NewsSchedule.vue?vue&type=template&id=a3e39204&scoped=true&"
import script from "./NewsSchedule.vue?vue&type=script&lang=ts&"
export * from "./NewsSchedule.vue?vue&type=script&lang=ts&"
import style0 from "./NewsSchedule.vue?vue&type=style&index=0&id=a3e39204&scoped=true&lang=css&"
import style1 from "./NewsSchedule.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e39204",
  null
  
)

export default component.exports